import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { cn } from '~/src/lib/utils'
import { useOnboardingActions } from '~/src/stores/useOnboardingStore'

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: string | React.ReactNode
  description?: string | React.ReactNode
  disableBack?: boolean
  titleClassName?: string
}

const OnboardingTitle: React.FC<Props> = ({
  title,
  description,
  disableBack,
  className,
  titleClassName,
}) => {
  const previousStep = useOnboardingActions().previousStep

  return (
    <div className={cn('relative space-y-3', className)}>
      {!disableBack && (
        <button
          className='flex h-10 w-16 items-center justify-center rounded-full bg-black/10 px-2 py-1 text-sm md:absolute md:right-full md:top-1 md:mr-4'
          onClick={previousStep}
        >
          <ArrowLeftIcon className='h-6 w-6' />
        </button>
      )}
      <div className='space-y-1'>
        <div
          className={cn('text-xl font-semibold md:text-3xl', titleClassName)}
        >
          {title}
        </div>
        {description && <div className='opacity-50'>{description}</div>}
      </div>
    </div>
  )
}

export default OnboardingTitle
